import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appPreventSpecialCharacters]',
  standalone: true,
})
export class PreventSpecialCharactersDirective {
  @Output() invalidCharacter = new EventEmitter<string>();

  private allowedPattern = /^[a-zA-ZáéíóúÁÉÍÓÚäëïöüÄËÏÖÜàèìòùÀÈÌÒÙñÑ,.\s]$/;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.key.length === 1 && !this.allowedPattern.test(event.key)) {
      event.preventDefault();
      this.invalidCharacter.emit(
        'No se permiten números ni caracteres especiales',
      );
    }
  }
}
